export class UrlParamsModel {
  orlenUID: string;
  partnerId: string;
  sid: string;
}
